import { render, staticRenderFns } from "./ForgotPasswordLink.vue?vue&type=template&id=c17c86ac&"
import script from "./ForgotPasswordLink.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports